import { Navigate, Route,Routes } from "react-router-dom";
import './App.css';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import ResultPage from "./pages/ResultPage";
import InputPage from "./pages/InputPage";
import HistoryPage from "./pages/HistoryPage";

function App() {
  return (
    <>
    <Routes>
      <Route path="/" element={<HomePage/>} />
      {/* <Route path="/about" element={<AboutPage/>} /> */}
      <Route path="/login" element={<LoginPage/>} />
      <Route path="/signup" element={<SignupPage/>} />
      <Route path="/result" element={<ResultPage/>} />
      <Route path="/page" element={<InputPage/>} />
      <Route path="/history" element={<HistoryPage/>} />
    </Routes>
  </>
  );
}

export default App;

